import clsx from "clsx";
import androidBack from "img/app-page/androidBack.png";
import backgroundDesk from "img/app-page/Back.png";
import screen2Generic from "img/app-page/Home.png";
import screen3Generic from "img/app-page/Sales.png";
import screen1 from "img/app-page/screen1.png";
import screen1Android from "img/app-page/screen1Android.png";
import screen1US from "img/app-page/screen1_us.png";
import screen2 from "img/app-page/screen2.png";
import screen2Android from "img/app-page/screen2Android.png";
import screen2US from "img/app-page/screen2_us.png";
import screen3 from "img/app-page/screen3.png";
import screen3Android from "img/app-page/screen3Android.png";
import screen3US from "img/app-page/screen3_us.png";
import screen1Generic from "img/app-page/Search.png";
import React, { useEffect, useRef, useState } from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import browser from "web/script/utils/browser";
import styles from "./styles.module.css";

let screenChangeInterval: NodeJS.Timeout;

interface SearchAndCompareComponentProps {
    branchLink: string;
}

export default function SearchAndCompareComponent({
    branchLink,
}: SearchAndCompareComponentProps): JSX.Element {
    const [currentScreen, setCurrentScreen] = useState(0);
    const [initialRender, setInitialRender] = useState(true);
    const filledBarRef = useRef<HTMLDivElement>(null);
    const ofThree = " / 3";
    const isUk = environment.get("country") === "GB";
    const browserDesktop = browser.getViewport() === browser.VIEWPORTS.DESKTOP;

    let imageArray: string[] = [];

    if (browserDesktop) {
        imageArray = [screen1Generic, screen2Generic, screen3Generic];
    } else if (browser.ios) {
        if (isUk) {
            imageArray = [screen1, screen2, screen3];
        } else {
            imageArray = [screen1US, screen2US, screen3US];
        }
    } else {
        imageArray = [screen1Android, screen2Android, screen3Android];
    }

    function resetAnimation(): void {
        const filledBar = filledBarRef?.current;
        if (filledBar) {
            filledBar.classList.remove(styles.filledBarAnimation);
            setTimeout(() => {
                filledBar.classList.add(styles.filledBarAnimation);
            }, 100);
        }
    }

    function setScreenChangeInterval(): void {
        screenChangeInterval = setInterval(() => {
            resetAnimation();
            const nextScreen = currentScreen < 2 ? currentScreen + 1 : 0;
            setCurrentScreen(nextScreen);
        }, 6000);
    }

    function changeScreen(nextInterval): void {
        clearInterval(screenChangeInterval);
        resetAnimation();
        setCurrentScreen(nextInterval);
        setScreenChangeInterval();
    }

    function nextScreen(): void {
        changeScreen(currentScreen < 2 ? currentScreen + 1 : 0);
    }

    function prevScreen(): void {
        changeScreen(currentScreen > 0 ? currentScreen - 1 : 2);
    }

    useEffect(() => {
        setScreenChangeInterval();
        return (): void => {
            if (screenChangeInterval) {
                clearInterval(screenChangeInterval);
            }
        };
    });

    // A hacky solution to browser.android not being recognised as a means to determine style below
    useEffect(() => {
        if (initialRender) {
            setCurrentScreen(0);
            setInitialRender(false);
        }
    }, [initialRender]);

    return (
        <div className={styles.searchAndCompare}>
            <div
                className={clsx({
                    [styles.screenText]: true,
                    [styles.multilineText]: currentScreen === 1,
                })}
            >
                {currentScreen === 0 && (
                    <h2 className={styles.text1}>
                        {gettext("app_landing.value_never_miss.title")}
                    </h2>
                )}
                {currentScreen === 1 && (
                    <h2 className={styles.text2}>
                        {gettext("app_landing.value_skip_scrolling.title")}
                    </h2>
                )}
                {currentScreen === 2 && (
                    <h2 className={styles.text3}>
                        {gettext("app_landing.value_express_style.title")}
                    </h2>
                )}
            </div>
            <div
                key={Date.now()}
                className={clsx({
                    [styles.phone]: browser.ios,
                    [styles.noBorderPhone]: !browser.ios,
                })}
            >
                {browser.ios && (
                    <>
                        <div className={styles.phoneNotch} />
                        <div className={styles.phoneBackground} />
                    </>
                )}
                {browser.android && (
                    <img src={androidBack} className={styles.phoneBackground} alt="phone-back" />
                )}
                {browserDesktop && (
                    <img src={backgroundDesk} className={styles.phoneBackground} alt="phone-back" />
                )}
                <BranchLink
                    branchLink={branchLink}
                    eventLabel={"screen_web_to_app_download"}
                    title={"screen_web_to_app_download"}
                >
                    <span>
                        {currentScreen === 0 && (
                            <img
                                src={imageArray[currentScreen]}
                                className={styles.phoneScreen}
                                alt="phone-background"
                            />
                        )}
                        {currentScreen === 1 && (
                            <img
                                src={imageArray[currentScreen]}
                                className={styles.phoneScreen}
                                alt="phone-background"
                            />
                        )}
                        {currentScreen === 2 && (
                            <img
                                src={imageArray[currentScreen]}
                                className={styles.phoneScreen}
                                alt="phone-background"
                            />
                        )}
                    </span>
                </BranchLink>
            </div>
            <div className={styles.stateControls}>
                <div className={styles.loadingBar}>
                    <div
                        ref={filledBarRef}
                        className={clsx(styles.filledBar, styles.filledBarAnimation)}
                    />
                </div>
                <div className={styles.screenNumber}>
                    {currentScreen + 1}
                    {ofThree}
                </div>
                <span className={styles.arrowCircle} onClick={nextScreen}>
                    <SVGIcon className={styles.arrowRight} name={"arrow-right"} />
                </span>
                <span className={styles.arrowCircle} onClick={prevScreen}>
                    <SVGIcon className={styles.arrowLeft} name={"arrow-right"} />
                </span>
            </div>
        </div>
    );
}
